/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2022 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */

export const cs_cz = {
  'Type something': 'Napiš něco',
  'About Jodit': 'O Jodit',
  'Jodit Editor': 'Editor Jodit',
  'Free Non-commercial Version': 'Verze pro nekomerční použití',
  "Jodit User's Guide": 'Jodit Uživatelská příručka',
  'contains detailed help for using': 'obsahuje detailní nápovědu',
  'For information about the license, please go to our website:':
    'Pro informace o licenci, prosím, přejděte na naši stránku:',
  'Buy full version': 'Koupit plnou verzi',
  'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
    'Copyright © XDSoft.net - Chupurnov Valeriy. Všechna práva vyhrazena.',
  Anchor: 'Anchor',
  'Open in new tab': 'Otevřít v nové záložce',
  'Open editor in fullsize': 'Otevřít v celoobrazovkovém režimu',
  'Clear Formatting': 'Vyčistit formátování',
  'Fill color or set the text color': 'Barva výplně a písma',
  Redo: 'Vpřed',
  Undo: 'Zpět',
  Bold: 'Tučné',
  Italic: 'Kurzíva',
  'Insert Unordered List': 'Odrážky',
  'Insert Ordered List': 'Číslovaný seznam',
  'Align Center': 'Zarovnat na střed',
  'Align Justify': 'Zarovnat do bloku',
  'Align Left': 'Zarovnat vlevo',
  'Align Right': 'Zarovnat vpravo',
  'Insert Horizontal Line': 'Vložit horizontální linku',
  'Insert Image': 'Vložit obrázek',
  'Insert file': 'Vložit soubor',
  'Insert youtube/vimeo video': 'Vložit video (YT/Vimeo)',
  'Insert link': 'Vložit odkaz',
  'Font size': 'Velikost písma',
  'Font family': 'Typ písma',
  'Insert format block': 'Formátovat blok',
  Normal: 'Normální text',
  'Heading 1': 'Nadpis 1',
  'Heading 2': 'Nadpis 2',
  'Heading 3': 'Nadpis 3',
  'Heading 4': 'Nadpis 4',
  Quote: 'Citát',
  Code: 'Kód',
  Insert: 'Vložit',
  'Insert table': 'Vložit tabulku',
  'Decrease Indent': 'Zmenšit odsazení',
  'Increase Indent': 'Zvětšit odsazení',
  'Select Special Character': 'Vybrat speciální symbol',
  'Insert Special Character': 'Vložit speciální symbol',
  'Paint format': 'Použít formát',
  'Change mode': 'Změnit mód',
  Margins: 'Okraje',
  top: 'horní',
  right: 'pravý',
  bottom: 'spodní',
  left: 'levý',
  Styles: 'Styly',
  Classes: 'Třídy',
  Align: 'Zarovnání',
  Right: 'Vpravo',
  Center: 'Na střed',
  Left: 'Vlevo',
  '--Not Set--': '--nenastaveno--',
  Src: 'src',
  Title: 'Titulek',
  Alternative: 'Alternativní text (alt)',
  Link: 'Link',
  'Open link in new tab': 'Otevřít link v nové záložce',
  Image: 'Obrázek',
  file: 'soubor',
  Advanced: 'Rozšířené',
  'Image properties': 'Vlastnosti obrázku',
  Cancel: 'Zpět',
  Ok: 'Ok',
  'Your code is similar to HTML. Keep as HTML?': 'Váš text se podobá HTML. Vložit ho jako HTML?',
  'Paste as HTML': 'Vložit jako HTML',
  Keep: 'Ponechat originál',
  Clean: 'Vyčistit',
  'Insert as Text': 'Vložit jako TEXT',
  'Insert only Text': 'Vložit pouze TEXT',
  'Word Paste Detected': 'Detekován fragment z Wordu nebo Excelu',
  'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
    'Obsah, který vkládáte, je pravděpodobně z Microsoft Word / Excel. Chcete ponechat formát nebo vložit pouze text?',
  'File Browser': 'Prohlížeč souborů',
  'Error on load list': 'Chyba při načítání seznamu souborů',
  'Error on load folders': 'Chyba při načítání složek',
  'Are you sure?': 'Jste si jistý(á)?',
  'Enter Directory name': 'Název složky',
  'Create directory': 'Vytvořit složku',
  'type name': 'název',
  'Drop image': 'Přetáhněte sem obrázek',
  'Drop file': 'Přetáhněte sem soubor',
  'or click': 'nebo klikněte',
  'Alternative text': 'Alternativní text',
  Browse: 'Server',
  Upload: 'Nahrát',
  Background: 'Pozadí',
  Text: 'Text',
  Top: 'Nahoru',
  Middle: 'Na střed',
  Bottom: 'Dolu',
  'Insert column before': 'Vložit sloupec před',
  'Insert column after': 'Vložit sloupec za',
  'Insert row above': 'Vložit řádek nad',
  'Insert row below': 'Vložit řádek pod',
  'Delete table': 'Vymazat tabulku',
  'Delete row': 'Vymazat řádku',
  'Delete column': 'Vymazat sloupec',
  'Empty cell': 'Vyčistit buňku',
  source: 'HTML',
  bold: 'tučně',
  italic: 'kurzíva',
  brush: 'štětec',
  link: 'odkaz',
  undo: 'zpět',
  redo: 'vpřed',
  table: 'tabulka',
  image: 'obrázek',
  eraser: 'guma',
  paragraph: 'odstavec',
  fontsize: 'velikost písma',
  video: 'video',
  font: 'písmo',
  about: 'о editoru',
  print: 'tisk',
  symbol: 'symbol',
  underline: 'podtrženo',
  strikethrough: 'přeškrtnuto',
  indent: 'zvětšit odsazení',
  outdent: 'zmenšit odsazení',
  fullsize: 'celoobrazovkový režim',
  shrink: 'smrsknout',
  copyformat: 'Kopírovat formát',
  hr: 'Linka',
  ul: 'Odrážka',
  ol: 'Číslovaný seznam',
  cut: 'Vyjmout',
  selectall: 'Označit vše',
  'Embed code': 'Kód',
  'Open link': 'Otevřít odkaz',
  'Edit link': 'Upravit odkaz',
  'No follow': 'Atribut no-follow',
  Unlink: 'Odstranit odkaz',
  Eye: 'Zobrazit',
  pencil: 'Chcete-li upravit',
  Update: 'Aktualizovat',
  ' URL': 'URL',
  Edit: 'Editovat',
  'Horizontal align': 'Horizontální zarovnání',
  Filter: 'Filtr',
  'Sort by changed': 'Dle poslední změny',
  'Sort by name': 'Dle názvu',
  'Sort by size': 'Dle velikosti',
  'Add folder': 'Přidat složku',
  Reset: 'Reset',
  Save: 'Uložit',
  'Save as ...': 'Uložit jako...',
  Resize: 'Změnit rozměr',
  Crop: 'Ořezat',
  Width: 'Šířka',
  Height: 'Výška',
  'Keep Aspect Ratio': 'Ponechat poměr',
  Yes: 'Ano',
  No: 'Ne',
  Remove: 'Vyjmout',
  Select: 'Označit',
  'Chars: %d': 'Znaky: %d',
  'Words: %d': 'Slova: %d',
  All: 'Vše',
  'Select %s': 'Označit %s',
  'Select all': 'Označit vše',
  'Vertical align': 'Vertikální zarovnání',
  Split: 'Rozdělit',
  'Split vertical': 'Rozdělit vertikálně',
  'Split horizontal': 'Rozdělit horizontálně',
  Merge: 'Spojit',
  'Add column': 'Přidat sloupec',
  'Add row': 'Přidat řádek',
  Delete: 'Vymazat',
  Border: 'Okraj',
  'License: %s': 'Licence: %s',
  'Strike through': 'Přeškrtnuto',
  Underline: 'Podtrženo',
  superscript: 'Horní index',
  subscript: 'Dolní index',
  'Cut selection': 'Vyjmout označené',
  Break: 'Zalomení',
  'Search for': 'Najdi',
  'Replace with': 'Nahradit za',
  Replace: 'Vyměňte',
  Paste: 'Vložit',
  'Choose Content to Paste': 'Vyber obsah pro vložení',
  'You can only edit your own images. Download this image on the host?':
    'Můžete upravovat pouze své obrázky. Načíst obrázek?',
  'The image has been successfully uploaded to the host!': 'Obrázek byl úspěšně nahrán!',
  palette: 'paleta',
  'There are no files': 'V tomto adresáři nejsou žádné soubory.',
  Rename: 'přejmenovat',
  'Enter new name': 'Zadejte nový název',
  preview: 'náhled',
  download: 'Stažení',
  'Paste from clipboard': 'Vložit ze schránky',
  "Your browser doesn't support direct access to the clipboard.":
    'Váš prohlížeč nepodporuje přímý přístup do schránky.',
  'Copy selection': 'Kopírovat výběr',
  copy: 'kopírování',
  'Border radius': 'Border radius',
  'Show all': 'Zobrazit všechny',
  Apply: 'Platí',
  'Please fill out this field': 'Prosím, vyplňte toto pole',
  'Please enter a web address': 'Prosím, zadejte webovou adresu',
  Default: 'Výchozí',
  Circle: 'Kruh',
  Dot: 'Dot',
  Quadrate: 'Quadrate',
  Find: 'Najít',
  'Find Previous': 'Najít Předchozí',
  'Find Next': 'Najít Další',
  'Insert className': 'Vložte název třídy',
  'Line height': 'Výška čáry',
  Spellchecking: 'Kontrola pravopisu',
}
